import React from 'react';

export default () => (
  <svg width="15" height="14" viewBox="-1 -1 17 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
      <path d="M0 11h15v3H0zM6 5V0h3v5zM3 5h9l-4.5 5z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/download.es6.js